module.exports = __webpack_public_path__ + "static/media/dhhx2_200x200.29c8bd53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/speakers/dhhx2_200x200.jpg
// module id = 215
// module chunks = 0